import { getAxiosConfig } from "@/services/axiosConfig";
import { ICategory, ICategoryGeneric } from "global-types/global.types";
import { useQuery } from "react-query";

export default function useHeader() {
  const { data, isLoading } = useQuery(["HEADER"], async () => {
    const res = await getAxiosConfig().get<ICategory<ICategoryGeneric[]>>(
      "/category"
    );

    return res.data;
  });

  return { data, isLoading };
}
